import { useResetPasswordMutation } from "../../redux";

const useResetPassword = () => {
    const [_reset, { isLoading, ...verifyData }] = useResetPasswordMutation();

    const reset = (emailAddress, resetCode, password) => {
        return new Promise((resolve, reject) => {
            return _reset({ emailAddress, resetCode, password })
                .unwrap()
                .then(
                    r => {
                        return resolve(r);
                    },
                    e => {
                        return reject(e);
                    }
                )
        });
    };

    return { reset, isLoading, data: { isLoading, ...verifyData } };
};

export default useResetPassword;